import { iaRa, inRn } from 'lib/helpers/utility';

export const calculateInvoiceAmounts = (invoice) => {
  return {
    subtotal: inRn(invoice.balance),
    discountAmount: inRn(invoice.discount),
    paidAmount: inRn(invoice.amount_paid),
    tax: inRn(invoice.tax),
    total: inRn(invoice.total_amount)
  };
};

export const calculateAmounts = (invoices) => {
  const totals = invoices.reduce(
    (acc, invoice) => {
      const { subtotal, discountAmount, paidAmount, tax, total } = calculateInvoiceAmounts(invoice);

      return {
        subtotal: acc.subtotal + subtotal,
        discountAmount: acc.discountAmount + discountAmount,
        paidAmount: acc.paidAmount + paidAmount,
        tax: acc.tax + tax,
        total: acc.total + total
      };
    },
    { subtotal: 0, discountAmount: 0, paidAmount: 0, tax: 0, total: 0 }
  );

  const balancePercentage = totals.total > 0 ? totals.subtotal / totals.total : 0;
  const proportionalTax = totals.tax * balancePercentage;

  const amountToPay = Math.max(0, totals.subtotal);

  return {
    subtotal: totals.subtotal,
    amountToPay,
    discountAmount: totals.discountAmount,
    paidAmount: totals.paidAmount,
    tax: proportionalTax
  };
};

export const processInvoices = (invoices, customPaymentAmounts = {}) => {
  return iaRa(invoices).map((invoice) => {
    const customAmount = customPaymentAmounts[invoice.id];
    const invoiceAmount = customAmount !== undefined ? customAmount : inRn(invoice.balance);
    return {
      ...invoice,
      balance: invoiceAmount
    };
  });
};

export const calculateAmountsForPayment = (
  invoices,
  practice,
  surchargeEnabled,
  setFieldValue,
  customPaymentAmounts = {},
  hasTechFeeModule = false
) => {
  const processedInvoices = processInvoices(invoices, customPaymentAmounts);

  setFieldValue('invoices', processedInvoices);

  const totalAmount = processedInvoices.reduce((sum, invoice) => sum + inRn(invoice.balance), 0);

  const amountToPay = Math.max(0, totalAmount);
  const isSurchargeEnabled = hasTechFeeModule && practice?.surcharge_enabled && surchargeEnabled;
  const surChargePercentage = (practice?.surcharge_percentage || 0) / 100;
  const surchargeAmount = isSurchargeEnabled ? Math.floor(amountToPay * surChargePercentage) : 0;
  setFieldValue('amount', amountToPay + surchargeAmount);
  setFieldValue('surchargeAmount', surchargeAmount);
  setFieldValue('appliedBalance', 0);
};
